
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import GlobalBus from '@/plugins/GlobalBus';
import { Getter } from 'vuex-class';
import Tree from './tree-view/Tree.vue';
import TransitionExpand from '../ui/TransitionExpand.vue';
import { TreeData } from '@/templates/Tree';
import { GlobalBusNames } from '@/templates/DataNames';

@Component({
  components: {
    Tree,
    TransitionExpand,
  },
})
export default class MobileMenu extends Vue {
  @Getter('getTree') treeData: TreeData;

  @Prop({ type: String, default: 'auto' }) height: string;
  public isOpenMenu = false;

  beforeDestroy() {
    GlobalBus.off(GlobalBusNames.CLOSEMOBILEMENU);
  }

  mounted() {
    // Если открыто меню когда мы переходим по результатам поиска в мобилке, его нужно закрыть
    GlobalBus.on(GlobalBusNames.CLOSEMOBILEMENU, () => {
      this.toggleMenu(false);
    });
  }

  toggleMenu(value: boolean) {
    this.isOpenMenu = value;
    GlobalBus.emit(GlobalBusNames.TOGGLEMOBILE, this.isOpenMenu);
  }
}
